import cars from './cars';
import website from './website';

export default {
  cars,
  website,
};
